
const base_url = "https://alphafold.ebi.ac.uk"; 
const pdbe_base_url = "https://www.ebi.ac.uk/pdbe"; 

export const environment = {
  production: true,
  baseUrl: base_url,
  uniprotApiUrl: "https://www.ebi.ac.uk/proteins/api/proteins/",
  uniprotEntryUrl: "https://www.uniprot.org/uniprot/",
  entryApiUrl: base_url + '/api/prediction/',
  pdbeApiUrl: pdbe_base_url + '/api/mappings/best_structures/',
  pdbeKbEntryUrl: pdbe_base_url + '/pdbe-kb/proteins/',
  googleAnalyticsTag: "G-RPJQZYPKWN",
  searchApiUrl: base_url + '/api/search',
  downloadApiUrl: base_url + '/api/download',
  suggestApiUrl: base_url + '/api/suggest',
  apiKey: "AIzaSyCeurAJz7ZGjPQUtEaerUkBZ3TaBkXrY94",
  swaggerApiUrl: base_url + '/api/openapi.json',
  clusterApiUrl: base_url + '/api/cluster/members/',
  structureSearchApiUrl: base_url + '/api/structure/search/',
  pdbeBaseApiUrl: pdbe_base_url,
  domainsApiUrl: base_url + '/api/domains/'
};